import { render, staticRenderFns } from "./OrgansAndRepresentatives.vue?vue&type=template&id=679271c2&scoped=true"
import script from "./OrgansAndRepresentatives.vue?vue&type=script&lang=js"
export * from "./OrgansAndRepresentatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679271c2",
  null
  
)

export default component.exports